import EditOrganizationPageModel from "../models/pageModels/EditOrganizationPageModel";
import Organization from "../models/serviceModels/Organization";

const mapOrganizationToEditOrganizationPageModel = (organization: Organization): EditOrganizationPageModel => {
    const visibleFields = organization.demographicsVisibleFields || ['pronouns', 'gender', 'ethnicity', 'race', 'address', 'city', 'state', 'zip', 'phone', 'email'];

    return {
        organizationAddressLine1: organization.addressLine1,
        organizationAddressLine2: organization.addressLine2,
        organizationCity: organization.city,
        organizationEmail: organization.email,
        organizationName: organization.name,
        organizationPhoneNumber: organization.phoneNumber,
        organizationState: organization.state,
        organizationZipCode: organization.zipCode,
        organizationUrl: organization.url || '',
        visiblePronouns: visibleFields.includes('pronouns'),
        visibleGender: visibleFields.includes('gender'),
        visibleEthnicity: visibleFields.includes('ethnicity'),
        visibleRace: visibleFields.includes('race'),
        visibleAddress: visibleFields.includes('address'),
        visibleCity: visibleFields.includes('city'),
        visibleState: visibleFields.includes('state'),
        visibleZip: visibleFields.includes('zip'),
        visiblePhone: visibleFields.includes('phone'),
        visibleEmail: visibleFields.includes('email'),
        demographicsGenderMode: organization.demographicsGenderMode || 'current',
        demographicsRaceMode: organization.demographicsRaceMode || 'separate',
        householdMemberParticipantMode: organization.householdMemberParticipantMode || 'defaultUnchecked',
        dateOfBirthRequired: false,
        dateOfBirthRequiredEffectiveDate: '',
        raceRequired: false,
        ethnicityRequired: false,
        genderRequired: false,
        pronounsRequired: false,
        addressRequired: false,
        cityRequired: false,
        stateRequired: false,
        zipRequired: false,
        phoneRequired: false,
        emailRequired: false
    };
};

export {
    mapOrganizationToEditOrganizationPageModel
}
